import React, { FC } from "react";
import View from "../components/View";

const FindRates: FC = () => {
  return (
    <View>
      <div className="flex w-full h-full bg-neutral-800">Find Rates</div>
    </View>
  );
};

export default FindRates;
